import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ArcoVue from '@arco-design/web-vue';
import '@arco-design/web-vue/dist/arco.css';
import i18n from './i18n';

import '@/utils/rem' // 引入rem适配


const app = createApp(App)

app.config.productionTip = false

createApp(App).use(router).use(i18n).use(ArcoVue).mount('#app')
